import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveCeilingStraight from "../assets/cave_ceiling_straight.png";

const Room3 = ({ goToRoom5, goToRoom6, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={caveCeilingStraight}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Buttons */}
        <button
          className={sharedStyles.button}
          style={{ top: "5%", left: "50%", position: "absolute" }}
          onClick={goToRoom5}
        >
          Up
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "48%", left: "50%", position: "absolute" }}
          onClick={goToRoom6}
        >
          Straight
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room3;